import { FC, useState, MouseEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useToggle } from 'react-use';

// icons
import { ReactComponent as ThreeDotsSvg } from 'assets/icons/menu.svg';
import { ReactComponent as EditSvg } from 'assets/icons/edit.svg';
import { ReactComponent as DeleteSvg } from 'assets/icons/trash.svg';

// hooks
import { useDeletePlaceholder } from 'hooks/placeholders';

// components
import { PlaceholderDialog } from '../PlaceholderDialog';

// types
import { PlaceholderResponse } from '@joc/api-gateway';

// styles
import styles from './PlaceholderActions.module.scss';

type PlaceholderActionsTypes = {
	placeholder: PlaceholderResponse;
};

const PlaceholderActions: FC<PlaceholderActionsTypes> = ({ placeholder }) => {
	const [showEditPopup, toggleEditPopup] = useToggle(false);
	const { deletePlaceholder } = useDeletePlaceholder();

	const [openItemId, setOpenItemId] = useState<number | null>(null);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleEditPlaceholder = () => {
		toggleEditPopup();
		handleActionsButtonClose();
	};

	const handleDeleteStatus = () => {
		handleActionsButtonClose();
		deletePlaceholder({ id: placeholder.id });
	};

	const handleActionsButtonClose = () => {
		setAnchorEl(null);
		setOpenItemId(null);
	};

	const handleActionsButtonClick = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
		setOpenItemId(placeholder.id);
	};

	return (
		<>
			<IconButton
				aria-label="actions"
				aria-controls={openItemId === placeholder.id ? 'long-menu' : undefined}
				onClick={event => handleActionsButtonClick(event)}
			>
				<ThreeDotsSvg className={openItemId === placeholder.id ? styles.active : ''} />
			</IconButton>
			<Menu
				open={openItemId === placeholder.id}
				anchorEl={anchorEl}
				onClose={handleActionsButtonClose}
				MenuListProps={{
					className: styles.actionsList,
				}}
				PaperProps={{
					className: styles.paper,
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 0,
					horizontal: 152,
				}}
			>
				<MenuItem className={styles.menuItem} onClick={handleEditPlaceholder}>
					<div className={styles.actionsContainer}>
						<EditSvg title="Edit status" />
						<span className={styles.actionsText}>Edit</span>
					</div>
				</MenuItem>
				<MenuItem className={styles.menuItem} onClick={handleDeleteStatus}>
					<div className={styles.actionsContainer}>
						<DeleteSvg title="Delete status" />
						<span className={styles.actionsText}>Delete</span>
					</div>
				</MenuItem>
			</Menu>

			<PlaceholderDialog placeholderToEdit={placeholder} open={showEditPopup} onClose={toggleEditPopup} />
		</>
	);
};

export default PlaceholderActions;
